import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.813 2.5A2.813 2.813 0 0 0 5 5.313V21.36l4.469-4.389a2.56 2.56 0 0 1 3.554-.008l3.295 3.16.028-.028c1-.957 2.557-.958 3.552-.006l5.078 4.976q.023-.187.024-.378V12.5h-7.187A2.813 2.813 0 0 1 15 9.688V2.5zm9.062.55v6.638c0 .516.42.937.938.937h6.638zM18.438 15a1.562 1.562 0 1 1 0 3.125 1.562 1.562 0 0 1 0-3.125m-7.188 3.126a.69.69 0 0 0-.476.19L5 23.987v.701A2.813 2.813 0 0 0 7.813 27.5h.948l6.215-6.067-3.251-3.116a.69.69 0 0 0-.475-.19m6.874 3.124a.7.7 0 0 0-.475.192L11.445 27.5h10.743a2.8 2.8 0 0 0 1.868-.712l-5.463-5.354a.67.67 0 0 0-.47-.184" }, null, -1)
  ]))]))
}
export default { render: render }